import React, { useEffect, useState } from "react";
import {
    Redirect,
    Route,
    Switch,
    useHistory,
    useLocation,
} from "react-router-dom";
import { RESET_LOADER, SET_LOADER } from "../../constants/contexConstant";
import { CONSUMER_TIMELINE_ENDPOINT } from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import useNetwork from "../../hooks/useNetwork";
import cn from "../../lib/cn";
import Container from "../../shared/Container";
import P from "../../shared/typography/P";
import Stepper from "../../shared/ui/Stepper";
import Activation from "./Activation";
import FeasibilitySurvey from "./FeasibilitySurvey";
import Instruction from "./Instruction";
import ProposalView from "./ProposalView";
import SalesExecutiveWrapper from "./SalesExecutiveWrapper";
import TimelineStepper from "./TimelineStepper";

const steps = ["Feasibility Survey", "Proposal", "Activation"];

const Timeline = () => {
    const [maxStep, setMaxStep] = useState(3);
    const [data, setData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentTab, setCurrentTab] = useState(1);
    const history = useHistory();
    const location = useLocation();
    const [currentSlide, setCurrentSlide] = useState(0);
    const { data: timelineData } = useNetwork(CONSUMER_TIMELINE_ENDPOINT);
    const { data: activationData } = useNetwork(
        `/workflow/run/${timelineData?.data?.data?.proposalId}`
    );

    const states = activationData?.data?.data?.states;
    const sortedStates = states?.sort((a, b) => a.id - b.id);

    const handleStep = (stepIndex) => {
        if (stepIndex > maxStep) return;

        const paths = ["feasibility", "proposal", "activation"];
        history.push(`/timeline/${paths[stepIndex - 1]}`);
    };

    const currentStepFromPath = () => {
        if (location.pathname.includes("proposal")) return 2;
        if (location.pathname.includes("activation")) return 3;
        return 1;
    };
    const { dispatch } = useContextState();
    useEffect(() => {
        if (!timelineData) {
            dispatch({ type: SET_LOADER });
        } else {
            dispatch({ type: RESET_LOADER });
        }
    }, [timelineData, dispatch]);
    useEffect(() => {}, [currentSlide]);

    return (
        <>
            <div className="min-h-screen font-vietnam md:bg-white md:pb-4">
                <div className="flex">
                    <div className="flex-1 bg-blue-700 md:bg-white min-h-screen w-full pt-[10rem] px-0 md:px-3 lg:w-1/2">
                        <div className="flex flex-col md:flex-row md:flex-wrap xl:flex-nowrap gap-2 justify-center items-center md:items-stretch">
                            <div className=" w-full md:p-1 md:hidden">
                                <Container>
                                    <Stepper
                                        steps={steps}
                                        currentStep={currentStepFromPath()}
                                        onClick={handleStep}
                                        showCurrentStep={false}
                                        theme={"dark"}
                                    />
                                </Container>
                            </div>
                            <Container className="md:hidden mb-1">
                                <div>
                                    <div className="flex justify-between items-center ">
                                        {currentStepFromPath() === 1 ? (
                                            <>
                                                <div
                                                    role="button"
                                                    onClick={() =>
                                                        setCurrentTab(1)
                                                    }
                                                >
                                                    <P
                                                        className={cn(
                                                            "text-gray-370",
                                                            {
                                                                "text-white border-b-2 border-b-blue pb-1 font-medium":
                                                                    currentTab ===
                                                                    1,
                                                            }
                                                        )}
                                                    >
                                                        Timeline
                                                    </P>
                                                </div>
                                                <div
                                                    role="button"
                                                    onClick={() =>
                                                        setCurrentTab(2)
                                                    }
                                                >
                                                    <P
                                                        className={cn(
                                                            "text-gray-370",
                                                            {
                                                                "text-white border-b-2 border-b-blue pb-1 font-medium":
                                                                    currentTab ===
                                                                    2,
                                                            }
                                                        )}
                                                    >
                                                        Instructions
                                                    </P>
                                                </div>
                                            </>
                                        ) : currentStepFromPath() === 2 ? (
                                            <>
                                                <div
                                                    role="button"
                                                    onClick={() => {
                                                        setCurrentSlide(0);
                                                        history.push(
                                                            "/timeline/proposal"
                                                        );
                                                    }}
                                                >
                                                    <P
                                                        className={cn(
                                                            "text-gray-370",
                                                            {
                                                                "text-white border-b-2 border-b-blue pb-1 font-medium":
                                                                    currentSlide ===
                                                                    0,
                                                            }
                                                        )}
                                                    >
                                                        Lease
                                                    </P>
                                                </div>
                                                <div
                                                    role="button"
                                                    onClick={() => {
                                                        setCurrentSlide(1);
                                                        history.push(
                                                            "/timeline/proposal"
                                                        );
                                                    }}
                                                >
                                                    <P
                                                        className={cn(
                                                            "text-gray-370",
                                                            {
                                                                "text-white border-b-2 border-b-blue pb-1 font-medium":
                                                                    currentSlide ===
                                                                    1,
                                                            }
                                                        )}
                                                    >
                                                        Purchase
                                                    </P>
                                                </div>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </Container>
                            <div className="hidden md:flex shadow-md rounded-3xl w-full xl:w-auto p-0.5">
                                <TimelineStepper
                                    currentStep={currentStepFromPath()}
                                    onClick={handleStep}
                                />
                            </div>

                            <div className="mt-0.5 w-full flex flex-col md:flex-row gap-3 items-stretch md:bg-white">
                                <Switch>
                                    <Route
                                        exact
                                        path="/timeline"
                                        render={() =>
                                            timelineData ? (
                                                <Redirect to="/timeline/feasibility" />
                                            ) : (
                                                ""
                                            )
                                        }
                                    />
                                    <Route
                                        path="/timeline/feasibility"
                                        render={() =>
                                            currentTab === 2 ? (
                                                <Instruction className="p-3 pb-[9rem]" />
                                            ) : (
                                                <FeasibilitySurvey
                                                    data={
                                                        timelineData?.data?.data
                                                    }
                                                />
                                            )
                                        }
                                    />
                                    {/* @TODO => Follow this Component @habib610 Wed July 09,2025 */}
                                    <Route
                                        path="/timeline/proposal"
                                        render={() => (
                                            <ProposalView
                                                url={"/timeline/proposal"}
                                                id={
                                                    timelineData?.data?.data
                                                        ?.proposalId
                                                }
                                                currentSlide={currentSlide}
                                                setCurrentSlide={
                                                    setCurrentSlide
                                                }
                                                setShowModal={setShowModal}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/timeline/activation"
                                        render={() => (
                                            <Activation
                                                data={sortedStates}
                                                setShowModal={setShowModal}
                                            />
                                        )}
                                    />
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SalesExecutiveWrapper
                setShowModal={setShowModal}
                showModal={showModal}
                assignee={timelineData?.data?.data?.assignee}
            />
        </>
    );
};

export default Timeline;
